import React, { Component } from 'react';
import { connect } from 'react-redux';

import Controls from '../../../../../components/Controls';
import DesignLoadingTable from '../DesignLoadingTable/DesignLoadingTable';
import '../../styles.scss';

import { 
  addCombination, 
  selectAllCombination, 
  removeSelected, 
  setImportState, 
  applyImport, 
  setImportData 
} from '@reducers/selectors/loads/actions';
import { createCombinationsFromInput, readFile, validateCombinationsInput } from '@services/helper.service';
import { APP_TEXTS } from '@texts';
import { callErrorNotification, callInfoNotification } from '@components/Notification';
import loadingParams from '../misc/loadingParams';
import { EventManager, EVENTS } from '@components/Events/events';
import ContextMenu from '@components/ContextMenu';

class TableWrapper extends Component {

  constructor() {
    super();
    this.onTabSwitched = this.onTabSwitched.bind(this);
    this.contextMenuRef = React.createRef();

    this.state = {
      componentMounted: false
    };
  }

  componentDidMount() {
    // document hooks will not be added since the child componentDidMount fires first and parentRef.current will be null
    // force the context menu to be rendered after this component mounted and parentRef.current was assigned
    this.setState({ componentMounted: true });
  }
  componentWillUnmount() {
    this.setState({ componentMounted: false });
  }

  render() {
    return (
      <div className="d-flex flex-column TableWrapper" ref={this.contextMenuRef}>
        {this.state.componentMounted && (
          <ContextMenu parentRef={this.contextMenuRef} canShow={!this.props.isImporting} items={[
            { id: 'paste_combinations', label: APP_TEXTS.CONTEXT_MENU_PASTE_COMBINATIONS.Content, onClick: () => this.onPasteData()}
          ]}/>
        )}

        <DesignLoadingTable
          areAllSelected={this.areAllSelected}
          combinations={this.props.isImporting ? this.props.importedCombinations : this.props.combinations}
          handleImportData={(data) => this.handleImportData(data)}
        />

        <Controls
          onAdd={this.props.addCombination}
          onRemove={this.props.removeSelected}
          canRemove={this.areAnySelected}
          isImporting={this.props.isImporting}
          onStartImport={() => this.onStartImport()}
          onConfirmImport={() => this.onConfirmImport()}
          onCancelImport={() => this.onCancelImport()}
        />
      </div>
    );
  }

  get areAnySelected() {
    return this.props.combinations.some(c => !c.isRemoved && c.isSelected);
  }

  get areAllSelected() {
    if (this.props.isImporting)
      return this.props.importedCombinations.length && this.props.importedCombinations.every(c => c.isSelected);
    else
      return this.props.combinations.length && this.props.combinations.every(c => c.isSelected);
  }

  onStartImport() {
    readFile('.csv,.tsv').then(file => this.handleImportData(file.contents));
  }

  onPasteData() {
    navigator.clipboard.readText().then(
      data => this.handleImportData(data), 
      () => {
        callErrorNotification(APP_TEXTS.NOTIFICATION_ERROR_ACCESS_CLIPBOARD.Content);
        callInfoNotification(APP_TEXTS.NOTIFICATION_ALTERNATIVE_PASTE_LOADS.Content);
      }
    );
  }

  handleImportData(data) {
    let validationResult = validateCombinationsInput(data);
    if (!validationResult.isValid)
      callErrorNotification(APP_TEXTS.NOTIFICATION_ERROR_PARSE_FILE.Content);
    else {
      let combinationsData;
      if (validationResult.cleanedInput)
        combinationsData = createCombinationsFromInput(validationResult, null, this.props.loadUnit, this.props.momentUnit);
      else 
        combinationsData = createCombinationsFromInput(validationResult, data, this.props.loadUnit, this.props.momentUnit);
      if (combinationsData && combinationsData.length && combinationsData.length > 0) {
        let loadHeaders = null;
        if (validationResult.hasHeaders) 
          loadHeaders = validationResult.headers.filter(h => loadingParams.findIndex(l => l.key === h) !== -1);
        this.props.setImportData(combinationsData, loadHeaders);
        EventManager.once(EVENTS.TAB_SWITCHED, this.onTabSwitched);
      }
    }
  }

  onConfirmImport() {
    EventManager.removeListener(EVENTS.TAB_SWITCHED, this.onTabSwitched);
    this.props.applyImport();
  }

  onCancelImport() {
    EventManager.removeListener(EVENTS.TAB_SWITCHED, this.onTabSwitched);
    this.props.setImportState(false);
  }

  onTabSwitched() {
    this.onCancelImport();
  }

}

const mapState = state => ({
  combinations: state.selectors.loads[state.main.appType].designLoadingData,
  isImporting: state.selectors.loads[state.main.appType].importState.isImporting,
  importedCombinations: state.selectors.loads[state.main.appType].importState.data,
  loadUnit: state.main.units.load,
  momentUnit: state.main.units.moment
});

const mapDispatch = dispatch => ({
  selectAll: checked => dispatch(selectAllCombination(checked)),
  addCombination: () => dispatch(addCombination()),
  removeSelected: () => dispatch(removeSelected()),
  setImportState: (value) => dispatch(setImportState(value)),
  setImportData: (data, headers) => dispatch(setImportData(data, headers)),
  applyImport: () => dispatch(applyImport())
});

export default connect(mapState, mapDispatch)(TableWrapper);



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/DesignLoading/DesignLoadingTable/index.js